// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"d9bbda72","288":"87b42e95","453":"7b676abe","496":"487eee28","540":"fe8696ee","551":"7e5a6a71","787":"e2c9ba6c","846":"9183664b","927":"65022888"}[chunkId] + ".chunk.js";
};